(() => {
  const root = document.documentElement;
  let observer;

  const mount = () => {
    observer?.disconnect();
    const card = document.querySelector('product-sticky-form .product-sticky-form__card');
    if (!card) {
      root.style.removeProperty('--hn-rewards-sticky-clearance');
      return;
    }

    const update = () => {
      const height = Math.ceil(card.getBoundingClientRect().height);
      root.style.setProperty('--hn-rewards-sticky-clearance', `${height > 0 ? height + 12 : 0}px`);
    };

    update();
    observer = new ResizeObserver(update);
    observer.observe(card);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
  document.addEventListener('shopify:section:load', mount);
})();
